module.exports = __webpack_public_path__ + "static/media/03-quote-01-monterrey@2x.a25873f6.jpg";